'use strict';

angular.module('clientDashboardApp').filter('localAreaFormat', function (pascalCaseFilter) {

  const regionRegex = /, (\w{2,3})$/

  return function (text) {
    if (!text) {
      return '';
    }

    let formattedLocation = pascalCaseFilter(text)
    if (formattedLocation.match(regionRegex)) {
      formattedLocation = formattedLocation.replace(regionRegex, (match, region, offset, locationString) => {
        return ", " + region.toUpperCase()
      })
    }

    return formattedLocation;
  };
});
